import { SET_PROCESSQUEUE, SYNC_PROCESSQUEUE, SET_LOADINGFLAG } from "../actions/types";

const initialData = {
  todayQueue: [],
  olderQueue: [],
  currentQueue: [],
  inProgress: false,
  refresh: true,
  fileUploadInProgress: false,
};

const STATUS = {
  1: "add",
  2: "remove",
};

//Hide and Show toast messages
export const processQueueReducer = (state = initialData, { type, payload }) => {
  switch (type) {
    case SET_PROCESSQUEUE:
      return { ...state, ...payload };
    case SYNC_PROCESSQUEUE: {
      let tempQueue = state.currentQueue;
      if (STATUS[payload.processState] === "add") tempQueue.push(payload);
      else tempQueue = state.currentQueue.filter((process) => process.ProcessQueue_id !== payload.ProcessQueue_id);
      let inProgress = tempQueue.length !== 0;
      return { ...state, inProgress, fileUploadInProgress: inProgress, currentQueue: tempQueue };
    }
    case SET_LOADINGFLAG:
      return { ...state, ...payload };
    default:
      return state;
  }
};
